import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';

function SessionExpiredAlert() {
  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="info">
        <AlertTitle>Session Expired</AlertTitle>
        Your session has expired due to inactivity. Please log in again to continue.
      </Alert>
    </Box>
  );
}

export default SessionExpiredAlert; 